var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAddOnOptions = function SvgAddOnOptions(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Add On Options",
    xmlns: "http://www.w3.org/2000/svg",
    width: 6,
    height: 26
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 97",
    fill: "#fff",
    stroke: "#4e4e4e"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 98",
    transform: "translate(0 10)",
    fill: "#fff",
    stroke: "#4e4e4e"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5,
    fill: "none"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 99",
    transform: "translate(0 20)",
    fill: "#fff",
    stroke: "#4e4e4e"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 2.5,
    fill: "none"
  }))));
};
export default SvgAddOnOptions;